export default {
  sendMoney: 'Send money',
  byPhoneNumber: 'By phone number',
  recipientPhoneNumber: 'Recipient phone number',
  inputPhoneNumber: 'Input phone number',
  continue: 'Continue',
  accountsFound:
    'We found several accounts associated with this number. Please select the account to proceed.',
  accountsNotFound: 'No accounts found for this beneficiary.',
  back: 'Back',
  selectAccount: 'Select account',
  note: 'Note',
  fromAccount: 'From account',
  amountToPay: 'Amount to pay',
  transactionDetails: 'Transaction Details',
  viewMore: 'View More',
  transfer: 'Transfer {{amount}}',
  chooseAnAccount: 'Choose an account',
  beneficiaryNotFound: 'Beneficiary not found. Please check the entered information and try again.',
  consentError: 'Error creating consent. Please try again.',
  byAccountNumber: 'By account number',
  recipientAccountNumber: 'Recipient account number',
  inputAccountNumber: 'Input account number',
  beneficiaryWillReceive: 'Beneficiary will receive',
  total: 'Total',
  phoneNumber: 'Phone number',
  beneficiaryAccount: 'Beneficiary account',
  beneficiaryName: 'Beneficiary name',
  amount: 'Amount',
  totalAmount: 'Total amount',
  paidTo: 'Paid to',
  transactionId: 'Transaction ID',
  status: 'Status',
  transferError: 'Error processing the transfer. Please try again later.',
  LIMIT_REACHED: 'Limit reached',
  NOT_SUFFICIENT_FUNDS: 'Not sufficient funds',
};
